import React from 'react';
export function extractStylesFromMarkComponent(MarkComponent, type) {
    // Create the element by calling the Mark component
    const element = MarkComponent({
        type,
        children: 'dummy',
    });
    // The MarkComponent returns a Box element with Chakra props
    if (React.isValidElement(element)) {
        const props = element.props;
        // Convert Chakra props to CSS styles
        return convertChakraPropsToStyle(props);
    }
    return {};
}
function convertChakraPropsToStyle(props) {
    const style = {};
    // Map of Chakra props to CSS properties
    const propMapping = {
        bg: 'backgroundColor',
        backgroundColor: 'backgroundColor',
        color: 'color',
        textDecoration: 'textDecoration',
        textDecorationLine: 'textDecorationLine',
        opacity: 'opacity',
        fontWeight: 'fontWeight',
        fontStyle: 'fontStyle',
        fontSize: 'fontSize',
        lineHeight: 'lineHeight',
        letterSpacing: 'letterSpacing',
        textTransform: 'textTransform',
        textAlign: 'textAlign',
    };
    // Extract relevant props and convert to CSS
    Object.entries(propMapping).forEach(([chakraProp, cssProp]) => {
        if (props[chakraProp] !== undefined) {
            style[cssProp] = props[chakraProp];
        }
    });
    return style;
}
//# sourceMappingURL=extractStyles.js.map